export const menuItems = [
  { label: "Centralny System Zgłoszeń", to: "/" },
  { label: "Niezbędnik SFH", to: "/niezbednik" },
  { label: "Pomoc techniczna", to: "/pomoc" },
];
